export default __webpack_public_path__ + "static/media/selector.4e452d18.svg";